import request, { METHODS } from "src/utils/api-base";

const publicInvoiceApis = {
  getPublicInvoice: (id: string) => {
    return request({
      route: `/app/public-invoice/${id}`,
      method: METHODS.GET,
      auth: false,
    });
  },
};

export default publicInvoiceApis;
